/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2472
 */

var r = require(/* 727 */"../../../../../../797/101/2466/2467/727/index")
var i = require(/* 538 */"../../../../../../797/101/2466/2467/538")
module.exports = function (e) {
  return i(e) && "[object Arguments]" == r(e)
}
